// extracted by mini-css-extract-plugin
export default {"select":"Search_select__XuRnE"};